import axios from "axios";
import Cookies from "js-cookie";
import { decryptRequest } from "../utils/encryptdecryptrequest";
import { toast } from "react-toastify";
import { Navigate, Router } from "react-router-dom";

let dynamicNodeURL = window.location.host.split("-");
if (dynamicNodeURL.length === 1) {
  // local server
  if (dynamicNodeURL[0].includes("localhost")) {
    dynamicNodeURL = `http://localhost:${process.env.REACT_APP_NODE_PORT}`;
  } else {
    // production
    dynamicNodeURL = `https://api-${dynamicNodeURL[0]}`;
  }
} else {
  // // non-prod
  // if (dynamicNodeURL[0] === "dev1") {
  //   // temporary setting
  //   dynamicNodeURL = `http://localhost:${process.env.REACT_APP_NODE_PORT}`;
  // } else {
  //   dynamicNodeURL = `https://${dynamicNodeURL[0]}-api-${dynamicNodeURL[1]}`;
  // }
  dynamicNodeURL = `https://${dynamicNodeURL[0]}-api-${dynamicNodeURL[1]}`;
}

const createAxiosInstance = () => {
  return axios.create({
    baseURL: dynamicNodeURL,
    headers: {
      "content-type": "application/json",
    },
    withCredentials: true,
  });
};

const axios_instance = createAxiosInstance();
const updateAxiosHeaders = () => {
  axios_instance.defaults.headers[
    "authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  axios_instance.defaults.headers["x-csrf-token"] =
    localStorage.getItem("csrfToken");
};

axios_instance.interceptors.request.use(
  (config) => {
    const loginToken = localStorage.getItem("token");
    const baseCsrfToken = localStorage.getItem("csrfToken");
    const csrfToken = sessionStorage.getItem("csrfToken");

    config.headers["X-CSRF-TOKEN"] = csrfToken ? csrfToken : baseCsrfToken;

    if (loginToken) config.headers["authorization"] = `Bearer ${loginToken}`;

    /*
    axios_instance.defaults.headers["x-csrf-token"] = sessionStorage.csrfToken
      ? sessionStorage.csrfToken
      : "";
    if (sessionStorage.csrfToken !== localStorage.csrfToken) {
      toast.dismiss();
      toast.error(
        "Your reqeust seems to be suspicious, Please refresh your page and try again."
      );
    }
    */
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios_instance.interceptors.response.use(
  (response) => {
    let csrfToken = Cookies.get("csrfToken");

    if (!csrfToken) csrfToken = response?.data?.csrfToken;

    if (csrfToken) {
      csrfToken = decryptRequest(csrfToken);
      localStorage.setItem("csrfToken", csrfToken);
      sessionStorage.setItem("csrfToken", csrfToken);
      updateAxiosHeaders();
    }
    return response;
  },
  (error) => {
    let csrfToken = Cookies.get("csrfToken");

    if (csrfToken) {
      csrfToken = decryptRequest(csrfToken);
      localStorage.setItem("csrfToken", csrfToken);
      const errorCode = error.response?.data?.error_code;

      if (errorCode === "csrf_mismatch") {
        toast.dismiss();
        toast.error(error.response.data.message);
      } else {
        sessionStorage.setItem("csrfToken", csrfToken);
      }
      updateAxiosHeaders();
    }

    if (!error.response) {
      toast.dismiss();
      toast.error(`${error.message}, Request Communication failure.`);
    }
    return Promise.reject(error);
  }
);

const axios_instance_without_headers = axios.create({
  baseURL: dynamicNodeURL,
  withCredentials: true,
});

export { axios_instance, axios_instance_without_headers, updateAxiosHeaders };
